import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import SalesTajmeea from "../views/SalesTajmeea";
import ListSales from "../views/ListSales";
import Brands from "../views/Brands";
import Store from "../views/Store";
import Cats from "../views/Cats";
import Clients from "../views/Clients";
import Payments from "../views/Payments";
import Users from "../views/Users";
import Profiles from "../views/Profiles";
import Shipping from "../views/Shipping";
import Providers from "../views/Providers";
import Purchases from "../views/Purchases";
import EditPurchase from "../views/EditPurchase";
import Print from "../views/Print";
import SalesReport from "../views/SalesReport";
import StoreReport from "../views/StoreReport";
import LogReport from "../views/LogReport";
import ClientReport from "../views/ClientReport";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/sales-tajmeea",
    name: "Sales Tajmeea",
    component: SalesTajmeea,
    props: true
  },
  {
    path: "/log-report",
    name: "Log Report",
    component: LogReport,
    props: true
  },
  {
    path: "/client-report",
    name: "Client Report",
    component: ClientReport,
    props: true
  },
  {
    path: "/sales-report",
    name: "Sales Report",
    component: SalesReport,
    props: true
  },
  {
    path: "/store-report",
    name: "Store Report",
    component: StoreReport,
    props: true
  },
  {
    path: "/store",
    name: "Store",
    component: Store
  },
  {
    path: "/clients",
    name: "Clients",
    component: Clients
  },
  {
    path: "/payments",
    name: "Payments",
    component: Payments
  },
  {
    path: "/users",
    name: "Users",
    component: Users
  },
  {
    path: "/list-sales",
    name: "List Sales",
    component: ListSales
  },
  {
    path: "/cats",
    name: "Categories",
    component: Cats
  },
  {
    path: "/brands",
    name: "Brands",
    component: Brands
  },
  {
    path: "/shipping",
    name: "Shipping",
    component: Shipping
  },
  {
    path: "/print",
    name: "Print",
    component: Print
  },
  {
    path: "/providers",
    name: "Providers",
    component: Providers
  },
  {
    path: "/purchases",
    name: "Purchases",
    component: Purchases
  },
  {
    path: "/editpurchase",
    name: "Edit Purchase",
    component: EditPurchase
  },
  {
    path: "/profiles",
    name: "Profiles",
    component: Profiles
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
